import QuotaManagerContent from './QuotaManagerContent.jsx';
import React, {useEffect} from 'react';
import copy from 'copy-to-clipboard';
import {Alert, Button, Dialog, DialogActions} from '@mui/material';
import {QUOTA_MANAGER_MODES} from '@app/constants/quotaManager';
import {bool, func, object, oneOf} from 'prop-types';
import {notify} from '@actions/notifications';
import {trackEvent} from '@app/analytics';
import {useDispatch} from 'react-redux';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {useTranslation} from 'react-i18next';

const QuotaManagerModal = ({open, onClose, collection, mode}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {hideQuotaModalCtas} = useFlags();

  const onCopyLink = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('collection', collection.id);

    const prettyURL = `${url.origin}${url.pathname}?${decodeURIComponent(url.searchParams.toString())}`;

    copy(prettyURL);

    dispatch(
      notify({
        message: t('common:copied'),
      })
    );

    trackEvent('Quota Manager Modal', {
      action: 'copied link',
      collectionId: collection.id,
      link: prettyURL,
    });
  };

  useEffect(() => {
    if (!collection) {
      onClose();
    }
  }, [collection, onClose]);

  return (
    <Dialog
      open={open}
      fullScreen
      hideBackdrop
      disableEnforceFocus
      sx={{
        top: theme => theme.mixins.topNav.height - 1,
        zIndex: theme => theme.zIndex.modal - 1,
      }}
    >
      <QuotaManagerContent
        collection={collection}
        onClose={onClose}
        mode={mode}
      />
      <DialogActions
        sx={{
          alignItems: 'center',
        }}
        disableSpacing
      >
        {mode === QUOTA_MANAGER_MODES.MANAGE && !hideQuotaModalCtas && (
          <Alert severity="info" sx={{marginLeft: 1}}>
            {t('quotaModal.manageAlert')}
          </Alert>
        )}

        {mode === QUOTA_MANAGER_MODES.PREVIEW && !hideQuotaModalCtas && (
          <Alert
            severity="info"
            sx={{marginLeft: 1}}
            action={
              <Button color="inherit" size="small" onClick={onCopyLink}>
                {t('quotaModal.previewCopyLinkBtn')}
              </Button>
            }
          >
            {t('quotaModal.previewAlert')}
          </Alert>
        )}

        <Button
          variant="contained"
          onClick={onClose}
          size="large"
          sx={{
            width: 300,
            marginLeft: 'auto',
            backgroundColor: 'grey.200',
            '&:hover': {
              backgroundColor: 'grey.300',
            },
          }}
        >
          {mode === QUOTA_MANAGER_MODES.PREVIEW
            ? t('quotaModal.previewCloseBtn')
            : t('quotaModal.manageCloseBtn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

QuotaManagerModal.propTypes = {
  open: bool,
  collection: object,
  onClose: func,
  mode: oneOf([QUOTA_MANAGER_MODES.MANAGE, QUOTA_MANAGER_MODES.PREVIEW]),
};

export default QuotaManagerModal;
